import styled from "styled-components"

export const StyledUserApplicationBreadcrumb = styled.div`
    padding-top: 24px;
    background: #fff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);


    .ant{
        &-tabs{
            &-nav{
                padding-top: 18px;
                margin-bottom: 0;

                &-list{

                    .ant-tabs-tab{
                        font-size: 16px !important;
                        line-height: 24px !important;

                        p{
                            margin-bottom: 0;
                        }

                        .applicationCount{
                            padding-left: 4px;
                        }
                    }

                    .ant-tabs-tab-active{

                        p{
                            font-weight: 500 !important;
                            color: rgba(0, 0, 0, 0.85);
                        }

                        .applicationCount{
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }
            }
        }
    }
`